import { useNavigate } from "react-router-dom";

//MUI
import { Box, Container, Stack, Typography } from "@mui/material";

// Images
import RoundedBox from "@Layouts/components/Basics/RoundedBox";
import Button from "@Layouts/components/Buttons/Button";
import PageLayer from "@/Layouts/views/PageLayer";

const LinkPrevious = () => {
	const navigate = useNavigate();
	return (
		<Button
			classes="!normal-case w-36 !font-['PtSansProNarrow'] !font-[400] !rounded-lg !bg-[var(--primary-color)]"
			variant="contained"
			onClick={() => navigate("/dashboard")}
			text="Go to Dashboard"
			disabledElevation={true}
		/>
	);
};

interface EspecialPagesProps {
	title: JSX.Element;
	description: string;
	image: string;
	imageAlt: string;
	imgBoxClasses: string;
}

const EspecialPages = (props: EspecialPagesProps) => {
	const { title, description, image, imageAlt, imgBoxClasses } = props;
	return (
		<PageLayer title="" icon={""} align="center" isDisabled>
			<Container disableGutters maxWidth={false} className="main-area p-5">
				<RoundedBox sx={{ minHeight: "630px" }}>
					<Stack direction={"row"} justifyContent={"space-between"}>
						<Box display={"flex"} justifyContent={"start"} alignItems={"start"}>
							<Stack className="mt-[123px] ml-[134px]" spacing={3} width={"240px"}>
								<Typography variant="h4" className="font-montserrat-semibold title-font-color">
									{title}
								</Typography>
								<Typography variant="body1" className="regular-pt-sans-pro-narrow-label" color={"var(--text-color)"}>
									{description}
								</Typography>
								<LinkPrevious />
							</Stack>
						</Box>
						<Box className={imgBoxClasses}>
							<img src={image} alt={imageAlt} />
						</Box>
					</Stack>
				</RoundedBox>
			</Container>
		</PageLayer>
	);
};

export default EspecialPages;
